<template>
  <UButton
    variant="link"
    color="primary"
    class="fixed focus:z-30 bg-white top-0 inset-x-0 h-10 text-center w-full flex justify-center align-middle focus-visible:ring-2"
    to="#main"
    external
    >{{ t('accessibility.skipLink') }}</UButton
  >
</template>
